// extracted by mini-css-extract-plugin
export default {"wrapper":"Language_wrapper__xU3tE","language":"Language_language__z83r1"};